var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7cd5d7d03184a26eb606c2269502ab4f0c0a4d12"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["help-center@klaviyo-1"]={id:"7cd5d7d03184a26eb606c2269502ab4f0c0a4d12"};
      